module.exports = __webpack_public_path__ + "img/b209032.webp";